import BluebeamLogo from 'components/Icons/BluebeamLogo';
import BluebeamLogoSmall from 'components/Icons/BluebeamLogoSmall';
import ProjectRoverHeader from 'components/Icons/ProjectRoverHeader';
import Truck from 'components/Icons/Truck';
import { environmentVars } from 'constants/services';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { ReactElement, useContext } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import './SideNav.css';
import { SheetQuery } from 'records/SheetQuery';

interface Props extends RouteComponentProps {
  children?: React.ReactNode;
  viewHeight: string;
}

const SideNav = (props: Props): ReactElement => {
  const { actions } = useContext(AppStoreContext);
  const { children, viewHeight, history } = props;

  const onLogoClick = async (): Promise<void> => {
    await actions.setSheetQuery(new SheetQuery());
    await actions.clearInteractions();
    await actions.clearAllModals();
    await actions.clearAllSelectedUsers();
    history.push('/my-workspace');
  };

  return (
    <>
      {/* 
          In order for the drop shadow on the sidebar to be visible,
          The element needs to be absolutely positioned, but this causes
          issues with z-indexing. The below div sits below the pos-a sidebar, 
          and maintains proper spacing of other elements.
        */}
      <div>
        <div className="sidenav-sizer" />
        {/* <div className="sidenav-sizer su-ws3 lu-wrem-9 min-ws3" /> */}
      </div>
      <div
        className="column sidenav-sizer pos-f"
        // className="column sidenav-sizer su-ws3 lu-wrem-9 pos-a"
        style={{
          flexShrink: 0,
          height: viewHeight,
          // boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
          // zIndex: 1,
        }}
      >
        {Boolean(environmentVars.BB_BRANDING) === false ? (
          <div
            className="min-hs3 bgd-primary-dark font-size-9 color-white stroke-white cursor-pointer"
            onClick={() => onLogoClick()}
          >
            <div className="sidenav-hide h100 flex-center">
              <Truck width="32px" height="22px" />
            </div>
            <div className="sidenav-show h100 row items-center">
              <ProjectRoverHeader width="144px" theme="dark" />
            </div>
          </div>
        ) : (
          <>
            <div
              className="min-hs3 bgd-white cursor-pointer w100 sidenav-show bb-3"
              onClick={() => onLogoClick()}
            >
              <BluebeamLogo width={124} location="sideNav" />
            </div>
            <div
              className="min-hs3 bgd-white cursor-pointer w100 sidenav-hide bb-3"
              onClick={() => onLogoClick()}
            >
              <BluebeamLogoSmall width={27} location="sideNav" />
            </div>
          </>
        )}

        <div className="bgd-primary-dark grow-1">{children}</div>
      </div>
    </>
  );
};

export default withRouter(SideNav);
